import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { replacePage, replaceLimit, replaceSearch } from './PurchaseOrders.slice'
import { paginate, deletePurchaseOrder } from './PurchaseOrders.thunk'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'
import HeadingRow from '../../components/HeadingRow'

interface PurchaseOrdersProps
  extends RouteComponentProps, ConnectedProps<typeof connector> {}

class PurchaseOrders extends Component<PurchaseOrdersProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Purchase order"), path: 'purchaseOrder.code' },
    { heading: i18n("Line"), path: 'purchaseOrder.line' },
    { heading: i18n("Vendor"), path: 'purchaseOrder.vendorSite.contact.vendor.name' },
    { heading: i18n("Item"), path: 'item.code' },
    { heading: i18n("Description"), path: 'item.description' },
    { heading: i18n("Line quantity"), path: 'quantity' },
    { heading: i18n("Received quantity"), path: 'receivedQuantity' },
    { heading: i18n("Delivery date"),
      path: 'purchaseOrder.deliveryAt',
      date: true
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: PurchaseOrdersProps) {
    super(props)
    this.handleEnterClick = this.handleEnterClick.bind(this)
    this.handleImportClick = this.handleImportClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
  }

  handleEnterClick () {
    this.props.history.push(routes.purchaseOrderEnter)
  }

  handleImportClick () {
    this.props.history.push(routes.purchaseOrdersImport)
  }

  handleActionClick (id: number, action: ActionName) {
    const { history } = this.props
    if (action === 'view') {
      const pathname = routes.purchaseOrder
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'edit') {
      const pathname = routes.purchaseOrderEdit
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the purchase order?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.props.deletePurchaseOrder(id)
      }
      confirmService.push(confirm)
    }
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleCreateClick () {
    this.props.history.push(routes.itemCreate)
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Purchase Orders")}
              doc='purchase-orders'>
              <Button
                text={i18n("Enter")}
                onClick={this.handleEnterClick} />
              <Button
                text={i18n("Import")}
                onClick={this.handleImportClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.purchaseOrders
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deletePurchaseOrder,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(PurchaseOrders))
